module.exports = __webpack_public_path__ + "static/media/Level1End.759252ab.mp4";